import { analytics } from './firebaseConfig';
import { logEvent } from "firebase/analytics";


export const trackCustomEvent = (eventName, eventParams = {}) => {
    logEvent(analytics, eventName, eventParams);
};